import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import {
  StatCard,
  StatCardIcon,
  StatCardBody,
  StatCardValue,
  StatCardLabel,
  TrendBadge,
  ValueSkeleton,
} from './Styles';
import { COLOR_MAP } from './Constant';
import type { StatCardProps } from './types';

const StatCardComponent: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color,
  onClick,
  trend,
  trendLabel,
  loading = false,
}) => {
  const accentColor = COLOR_MAP[color] || color;
  const iconBg = `${accentColor}20`;
  const trendColor =
    trend !== undefined
      ? trend > 0
        ? "#52c41a"
        : trend < 0
        ? "#ff4d4f"
        : "#8c8c8c"
      : "#8c8c8c";

  const trendIcon =
    trend !== undefined
      ? trend > 0
        ? faArrowTrendUp
        : trend < 0
        ? faArrowTrendDown
        : faMinus
      : null;

  return (
    <StatCard onClick={onClick}>
      <StatCardIcon bg={iconBg} color={accentColor}>
        <FontAwesomeIcon icon={icon} />
      </StatCardIcon>

      <StatCardBody>
        {loading ? (
          <ValueSkeleton active />
        ) : (
          <StatCardValue>{value}</StatCardValue>
        )}
        <StatCardLabel>{title}</StatCardLabel>
        {trend !== undefined && !loading && (
          <TrendBadge color={trendColor}>
            <FontAwesomeIcon icon={trendIcon || faMinus} />
            <span>
              {trend > 0 ? "+" : ""}
              {trend}%{trendLabel ? ` ${trendLabel}` : ""}
            </span>
          </TrendBadge>
        )}
      </StatCardBody>
    </StatCard>
  );
};

export default StatCardComponent;
